import { render, staticRenderFns } from "./cabinet-deals-item.vue?vue&type=template&id=c0607ae2&scoped=true"
import script from "./cabinet-deals-item.vue?vue&type=script&lang=js"
export * from "./cabinet-deals-item.vue?vue&type=script&lang=js"
import style0 from "./cabinet-deals-item.vue?vue&type=style&index=0&id=c0607ae2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0607ae2",
  null
  
)

export default component.exports